import lightFormat from 'date-fns/lightFormat';
import { EServiceId, IServicePackage } from '../../../../../../../redux/reducers';
import { IPreparedPackage } from '../types';

const PACKAGE_NAMES: { [serviceId in EServiceId]: string } = {
  [EServiceId.top]: 'Топ',
  [EServiceId.premium]: 'Премиум',
  [EServiceId.paid]: 'Публикация',
  [EServiceId.free]: 'Публикация',
};

const DATE_PATTERN = 'dd.MM';

export function preparePackages(packages: IServicePackage[]): IPreparedPackage[] {
  return packages.map(servicePackage => {
    const { id, servicePackageEndDate: endDate, servicePackageActualCount: count, serviceId } = servicePackage;

    const formattedEndDate = lightFormat(new Date(endDate), DATE_PATTERN);
    const packageName = PACKAGE_NAMES[serviceId];

    const description = count ? `(доступно ${count} до ${formattedEndDate})` : `(до ${formattedEndDate})`;

    return {
      value: id,
      label: `${packageName} ${description}`,
    };
  });
}
